import { PERCENT_SCALE } from '@air/utilities';

import {
  type CoverImageRegion,
  getCoverImageFocalPoint,
} from '~/components/v2/components/showcase/getCoverImageFocalPoint';

export const getCoverImageObjectPosition = (region: CoverImageRegion): string => {
  const { x, y } = getCoverImageFocalPoint(region);

  return `${x * PERCENT_SCALE}% ${y * PERCENT_SCALE}%`;
};
